import { Card, type CardRootProps } from '@chakra-ui/react';

export type CardWithTitleProps = CardRootProps & {
	title:    React.ReactNode;
	description?: React.ReactNode;
	children: React.ReactNode;
};

export const CardWithTitle = ({ 
	title, 
	description,
	children, 
	...props 
}: CardWithTitleProps) => {
	return (
		<Card.Root {...props}>
			<Card.Header>
				<Card.Title>{title}</Card.Title>
				{description && <Card.Description>{description}</Card.Description>}
			</Card.Header>
			<Card.Body>
				{children}
			</Card.Body>
			<Card.Footer />
		</Card.Root>
	);
};
